export default "/static/vaccine/book.png"